module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "primary-btn",
    class: {
      status0: _vm.status === 0, status2: _vm.status === 2
    }
  }, [_c('p', {
    attrs: {
      "id": "bd-share-poster"
    },
    on: {
      "click": _vm.clickHandler
    }
  }, [_vm._v(_vm._s(_vm.text))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-44c1e188","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PrimaryBtn.vue
// module id = 431
// module chunks = 1